import React, { ReactNode } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useRootStore } from 'core/hooks/use-root-store';
import { EmployerLoginStore } from './employer-login.store';

const EmployerLoginContext = React.createContext<EmployerLoginStore | null>(null);

export const EmployerLoginProvider = ({ children }: { children: ReactNode }) => {
   const rootStore = useRootStore();
   const { i18n, t } = useTranslation('global');

   const selectedLanguage = Cookies.get('selectedLanguage') || i18n.language || 'ukr';
   const apiLanguage = selectedLanguage === 'ukr' ? 'uk' : selectedLanguage;

   const [store] = React.useState<EmployerLoginStore>(
      () => new EmployerLoginStore(rootStore, t, apiLanguage)
   );

   return <EmployerLoginContext.Provider value={store}>{children}</EmployerLoginContext.Provider>;
};

export const useEmployerLogin = (): EmployerLoginStore => {
   const ctx = React.useContext(EmployerLoginContext);
   if (!ctx) {
      throw new Error('useEmployerLogin must be used inside EmployerLoginProvider');
   }
   return ctx;
};
